import { render, staticRenderFns } from "./InputConveyancers.vue?vue&type=template&id=dbf87a5a"
import script from "./InputConveyancers.vue?vue&type=script&lang=js"
export * from "./InputConveyancers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports